export default __webpack_public_path__ + "static/media/recharge_logo.0fed8565.png";